import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AvailabilityLoader from 'organisms/Loaders/AvailabilityLoader';
import {
  activateRecurringDay,
  availabilitySuccess,
  removeRecurringDay,
} from 'store/reducers/recurringAvailability';
import { weekdays } from 'util/constants';

import DeleteDayModal from '../../Modals/DeleteDayModal';
import AvailabilityList from './AvailabilityList';

export default function RecurringSection() {
  const dispatch = useDispatch();
  const [isDeleteSlotOpen, openDeleteSlot] = useState();
  const [dayToRemove, setDayToRemove] = useState();
  const { selectedGroomer } = useSelector((state) => state.ui);
  const { recurringDOW } = useSelector((state) => state.inventory);
  const { recurring, isLoading } = useSelector(
    (state) => state.recurringAvailability
  );
  const providerLocations = useSelector((state) => state.provider.locations);
  const providerHours = providerLocations[0]?.hours;
  const providerIncrement = providerLocations[0]?.minApptLengthSecs;
  const openDays = providerHours?.map((el) => el.dow.value);

  useEffect(() => {
    dispatch(availabilitySuccess(recurringDOW));
  }, [selectedGroomer]);

  const checkboxAction = (isActive, day) => {
    if (!isActive) {
      // Check if we shouldn't display warning modal. If so, remove action now
      if (localStorage.getItem('hideAvailabilityRemovalModal')) {
        triggerRemovingAction(day);
      } else {
        setDayToRemove(day);
        openDeleteSlot(true);
      }
    } else {
      dispatch(
        activateRecurringDay({
          day,
          openHours: providerHours,
          increment: providerIncrement,
        })
      );
    }
  };

  const triggerRemovingAction = (dow) => {
    dispatch(removeRecurringDay({ dow: dow || dayToRemove }));
  };

  return (
    <div className="mb-12 p-24 border-light-purple radius-24 w-100 flex-column justify-between">
      <h4 className="f16 mb-15">Recurring</h4>
      <div className="recurrent-availability">
        <div className="flex-column recurrent-availability-container">
          {isLoading ? (
            <AvailabilityLoader />
          ) : (
            <AvailabilityList
              weekdays={weekdays}
              recurring={recurring}
              openDays={openDays}
              checkboxAction={checkboxAction}
            />
          )}
        </div>
      </div>
      <DeleteDayModal
        isOpen={isDeleteSlotOpen}
        onClose={openDeleteSlot}
        onRemoveRange={triggerRemovingAction}
        variant="day"
      />
    </div>
  );
}
